import React from 'react';

export interface PricePerKwhData {
  label: string;
  value: string;
  labelTestId: string;
  valueTestId: string;
}

export interface BasePriceData {
  label: string;
  value: string;
}

interface PricePerKwhRowProps {
  label: string;
  value: string;
  labelTestId: string;
  valueTestId: string;
  className?: string;
  labelClassName?: string;
}

function PricePerKwhRow({
  label,
  value,
  labelTestId,
  valueTestId,
  className,
  labelClassName,
}: PricePerKwhRowProps) {
  return (
    <div className={className}>
      <span data-testid={labelTestId} className={labelClassName}>
        {label}
      </span>
      <span data-testid={valueTestId} className="font-semibold">
        {value}
      </span>
    </div>
  );
}

interface BreakdownHeaderProps {
  pricePerKwh: PricePerKwhData;
  basePricePerMonth?: BasePriceData;
}

export default function BreakdownHeader({
  pricePerKwh,
  basePricePerMonth,
}: BreakdownHeaderProps) {
  if (!basePricePerMonth) {
    return (
      <PricePerKwhRow
        label={pricePerKwh.label}
        value={pricePerKwh.value}
        labelTestId={pricePerKwh.labelTestId}
        valueTestId={pricePerKwh.valueTestId}
        labelClassName="pr-12"
      />
    );
  }

  return (
    <div className="w-full space-y-2">
      <PricePerKwhRow
        label={pricePerKwh.label}
        value={pricePerKwh.value}
        labelTestId={pricePerKwh.labelTestId}
        valueTestId={pricePerKwh.valueTestId}
        className="flex items-center justify-between gap-4"
      />
      <div className="flex items-center justify-between gap-4">
        <span>{basePricePerMonth.label}</span>
        <span className="font-semibold">{basePricePerMonth.value}</span>
      </div>
    </div>
  );
}
